export default "__VITE_ASSET__DBHU8vKm__"